import { Button } from "antd";
import { useTranslation } from "react-i18next";

const CustomActionFooter = ({ form, hideBackButton, onBackClick, handleCloseModal, onOkModal }) => {
    const { t } = useTranslation();

    return (
        <div style={{ textAlign: 'right', marginTop: '20px' }}>
            {!hideBackButton &&
                <Button type="primary" onClick={onBackClick} >
                    {t("Back")}
                </Button>
            }
            <Button type="default" onClick={() => { handleCloseModal(); form.resetFields(); }}>
                {t("Cancel")}
            </Button>
            <Button type="primary" onClick={() => {
                form
                    .validateFields() // Validate and get form values
                    .then((values) => {
                        onOkModal(values);
                    })
                    .catch((info) => {
                        console.log('Validation Failed:', info);
                    });
            }}>
                {t("Ok")}
            </Button>
        </div >
    );
}

export default CustomActionFooter;